import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddRoundIcon } from 'assets/icon-add-round.svg';
import { ReactComponent as GroupIcon } from 'assets/icon-process-step.svg';
import { ReactComponent as TextFieldIcon } from 'assets/icon-text-field.svg';
import { ReactComponent as TextAreaIcon } from 'assets/icon-text-edit.svg';
import { ReactComponent as NumberIcon } from 'assets/icon-number-ten.svg';
import { ReactComponent as CoinIcon } from 'assets/icon-coin.svg';
import { ReactComponent as SimpleListIcon } from 'assets/icon-dropdown.svg';
import { ReactComponent as MultipleSelectorIcon } from 'assets/icon-practical-cases.svg';
import { ReactComponent as OptionBooleanIcon } from 'assets/icon-switch-left.svg';
import { ReactComponent as DateIcon } from 'assets/icon-calendar.svg';

import BackgroundBox from 'shared/components/BackgroundBox';

import FieldType from 'shared/helpers/fieldType';

import { CustomFieldSelectorWrapper, CustomFieldText, SelectorItem } from './styles';

const CustomFieldSelector = ({ onSelect }) => {
  const { t } = useTranslation();
  const onClickSelectItem = (fieldType) => onSelect(fieldType);
  return (
    <CustomFieldSelectorWrapper>
      <BackgroundBox className="backgroundbox">
        <div className="backgroundbox-header">
          <CustomFieldText>{t('custom_field_select_field')}</CustomFieldText>
          <AddRoundIcon />
        </div>
        <div className="backgroundbox-body">
          <SelectorItem onClick={() => onClickSelectItem(FieldType.GROUP)}>
            <GroupIcon />
            <CustomFieldText>{t('custom_field_group_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.TEXT)}>
            <TextFieldIcon />
            <CustomFieldText>{t('custom_field_text_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.TEXT_AREA)}>
            <TextAreaIcon />
            <CustomFieldText>{t('custom_field_textarea_field')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.NUMBER)}>
            <NumberIcon />
            <CustomFieldText>{t('custom_field_number_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.CURRENCY)}>
            <CoinIcon />
            <CustomFieldText>{t('custom_field_currency_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.LIST)}>
            <SimpleListIcon />
            <CustomFieldText>{t('custom_field_simple_list_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.MULTI_LIST)}>
            <MultipleSelectorIcon />
            <CustomFieldText>{t('custom_field_multiple_selection_list_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.OPTION)}>
            <OptionBooleanIcon />
            <CustomFieldText>{t('custom_field_option_fields')}</CustomFieldText>
          </SelectorItem>
          <SelectorItem onClick={() => onClickSelectItem(FieldType.CALENDAR)}>
            <DateIcon />
            <CustomFieldText>{t('custom_field_date_fields')}</CustomFieldText>
          </SelectorItem>
        </div>
      </BackgroundBox>
    </CustomFieldSelectorWrapper>
  );
};

CustomFieldSelector.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default CustomFieldSelector;
